module.exports = __webpack_public_path__ + "static/media/client-empty.d5074839.png";